import React, { useState } from 'react';
import { API_BASE_URL } from '../config/api';

const initials = (name = '') =>
  name.split(/\s+/).filter(Boolean).slice(0, 2).map((w) => w[0].toUpperCase()).join('') || 'T';
const photoSrc = (p) => (!p ? null : /^(https?:|data:)/.test(p) ? p : `${API_BASE_URL}${p}`);

// Digital identity card for the teacher landing view.
function TeacherSmartCard({ user, cls, present, total, marked, onMark }) {
  const [failed, setFailed] = useState(false);
  const src = failed ? null : photoSrc(user.profilePicture);
  const role = user.designation || 'Teacher';
  const line = [cls ? `${role} - ${cls}` : role, user.subject].filter(Boolean).join(' | ');

  return (
    <header className="th-idcard">
      <div className={`th-avatar ${marked ? 'th-ring-ok' : 'th-ring-warn'}`}>
        {src ? <img src={src} alt="" onError={() => setFailed(true)} /> : <span>{initials(user.name)}</span>}
      </div>
      <div className="th-id-info">
        <div className="th-id-name">{user.name}</div>
        <div className="th-id-line">{line}</div>
        <span className={`th-id-pill ${marked ? 'th-id-ok' : 'th-id-warn'}`}>
          Today’s Attendance: {marked ? `Marked (${present}/${total})` : 'Not Marked'}
        </span>
      </div>
      <button className="th-id-btn" onClick={onMark}>{marked ? 'Edit P/A' : 'Mark P/A Now'}</button>
    </header>
  );
}

export default TeacherSmartCard;
